let baseURL = "";
if (process.env.NODE_ENV === "development") {
  // 测试环境境
  baseURL = "https://train-service-api.procaregroup.com";
} else {
  // 正式环境
  baseURL = "https://train-service-api.procaregroup.com";
}
export default baseURL;
